import React from 'react';

const PaymentSuccess = () => {
  return (
    <div className="payment-success">
      <h2>Payment Successful!</h2>
      <p>Thank you for your payment. We will begin sourcing your perfect car.</p>
    </div>
  );
};

export default PaymentSuccess;
